import React from 'react';
import { Box, Flex } from 'rebass/styled-components';

export const SignupFormSkeleton = () => (
  <Flex
    sx={{
      flexDirection: 'column',
      height: '100%',
      px: '16px',
      py: '48px',
    }}
  >
    <Flex
      sx={{
        flexDirection: 'column',
        gap: '40px',
        maxWidth: '800px',
        width: '100%',
        margin: '0px auto',
      }}
    >
      {/* Header skeleton */}
      <Flex sx={{ flexDirection: 'column', gap: '8px' }}>
        <Box sx={{ height: '24px', width: '180px', bg: 'neutral.100', borderRadius: '4px' }} />
        <Box sx={{ height: '16px', width: '300px', bg: 'neutral.50', borderRadius: '4px' }} />
        <Box sx={{ height: '48px', width: '100%', bg: 'neutral.50', borderRadius: '4px', mt: '8px' }} />
      </Flex>

      {/* Form customization skeleton */}
      <Flex sx={{ flexDirection: 'column', gap: '8px' }}>
        <Box sx={{ height: '24px', width: '160px', bg: 'neutral.100', borderRadius: '4px' }} />
        <Box sx={{ height: '16px', width: '280px', bg: 'neutral.50', borderRadius: '4px' }} />
        <Flex sx={{ gap: '8px', mt: '8px' }}>
          <Box sx={{ height: '32px', width: '80px', bg: 'neutral.50', borderRadius: '4px' }} />
          <Box sx={{ height: '32px', width: '140px', bg: 'neutral.50', borderRadius: '4px' }} />
        </Flex>
      </Flex>

      {/* Agent section skeleton */}
      <Box sx={{ height: '200px', width: '100%', bg: 'neutral.50', borderRadius: '4px' }} />
    </Flex>
  </Flex>
);
